import { Block } from '@/administration/pages/Course/store/block/types';
import { PageId } from '@/administration/pages/Course/store/types';

export enum PageVariant {
  TEXT = 'TEXT',
  RESULT = 'RESULT',
  QUESTION = 'QUESTION',
  PRACTICAL_ASSESSMENT_TEXT = 'PRACTICAL_ASSESSMENT_TEXT',
  PRACTICAL_ASSESSMENT_DOCUMENT = 'PRACTICAL_ASSESSMENT_DOCUMENT',
  // actual ones go below
  REFLECTION = 'REFLECTION',
  MODULE = 'MODULE',
  PAGE = 'PAGE',
  QUIZ = 'QUIZ',
  ASSIGNMENT = 'ASSIGNMENT',
}

export enum PageVariantDeprecated {
  TEXT = 'TEXT',
  RESULT = 'RESULT',
  QUESTION = 'QUESTION',
  PRACTICAL_ASSESSMENT_TEXT = 'PRACTICAL_ASSESSMENT_TEXT',
  PRACTICAL_ASSESSMENT_DOCUMENT = 'PRACTICAL_ASSESSMENT_DOCUMENT',
  PRACTICAL_ASSESSMENT_VIDEO = 'PRACTICAL_ASSESSMENT_VIDEO',
  REFLECTION = 'REFLECTION',
  QUIZ = 'QUIZ',
}

export type Page = {
  id: PageId;
  remoteId?: number;

  title: string;

  type: PageVariantDeprecated;
  block: Block;

  active?: boolean;
  hasError?: boolean;
  completed?: boolean;
};
